export default __webpack_public_path__ + "./images/ya-eng.ddc94212.svg";